import { useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../../../../hooks";
import { EnergyPerformanceInstallationform } from "../../../../api";
import { avisarSoloLectura, useSoloLectura } from "../engine";

const energyPerformanceCtrl = new EnergyPerformanceInstallationform();

// Subir y borrar archivos de evidencia (documentos y formulario). Se guardan en el momento:
//  - subir: primero el archivo, después la lista que lo referencia (guardar);
//  - borrar: primero el archivo (el servidor exige que siga referenciado para autorizarlo), después la lista.
// site: sitio de la instalación; el servidor lo verifica y deja el archivo a nombre de ese sitio.
export function useEvidencias(guardar, t, site) {
  const { accessToken } = useAuth();
  const soloLectura = useSoloLectura();
  const [ocupado, setOcupado] = useState(false);

  const subir = async (file, armarCambios) => {
    if (!file) return false;
    if (soloLectura) { avisarSoloLectura(t, soloLectura); return false; }
    setOcupado(true);
    try {
      const fd = new FormData();
      fd.append("site", site);
      fd.append("files", file);
      const res = await energyPerformanceCtrl.uploadEvidence(accessToken, fd);
      const subido = res.files && res.files[0];
      return await guardar(armarCambios({ nombre: subido.name, archivo: subido.uniqueName }));
    } catch (error) {
      toast.error(error?.msg || error?.message || t("server_connection_error"));
      return false;
    } finally {
      setOcupado(false);
    }
  };

  const borrar = async (archivo, cambios) => {
    if (soloLectura) { avisarSoloLectura(t, soloLectura); return false; }
    setOcupado(true);
    try {
      if (archivo) await energyPerformanceCtrl.deleteEvidence(accessToken, archivo);
      return await guardar(cambios);
    } catch (error) {
      toast.error(error?.msg || error?.message || t("server_connection_error"));
      return false;
    } finally {
      setOcupado(false);
    }
  };

  // El endpoint pide el token: se baja con fetch y se abre como blob (un enlace directo no llevaría la sesión).
  const ver = async (archivo) => {
    try {
      const res = await fetch(energyPerformanceCtrl.getEvidenceUrl(archivo), { headers: { Authorization: `Bearer ${accessToken}` } });
      if (!res.ok) throw new Error(t("energy_performance_evidence_not_found"));
      const blob = await res.blob();
      window.open(URL.createObjectURL(blob), "_blank", "noopener");
    } catch (error) {
      toast.error(error?.message || t("server_connection_error"));
    }
  };

  return { subir, borrar, ver, ocupado };
}
